import React, { useState, useEffect } from "react";
// import api from "api";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Edit, Trash2 } from "react-feather";
import Table from "../../core/pagination/datatable";
import CommonFooter from "../../core/common/footer/commonFooter";
import TooltipIcons from "../../core/common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../core/common/tooltip-content/collapes";
import { MinusCircle, PlusCircle } from "react-feather";
import "../../css/app.css";

import CommonDeleteModal from "../../core/common/modal/commonDeleteModal";
import {
  createStock,
  updateStock,
  getAllStocks,
  deleteStock,
} from "../../api/stockManagementApi.js";
import { toast } from "react-toastify";
import { getAllWarehouses, getWarehouseById } from "../../api/warehouseApi";
import { getAllStores } from "../../api/storeApi";
import { api } from "../../api/client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const DEFAULT_STOCK_IMAGE = "/assets/img/by-default.png";

// ---------- S3 helpers (same convention you used elsewhere) ----------
const normalizeKey = (s) => {
  if (!s) return "";
  let v = String(s).trim();
  v = v.replace(/^\/+/, "");
  v = v.replace(/^catelog\//i, "catalog/"); // fix legacy typo
  if (!/^catalog\//i.test(v)) {
    v = `catalog/${v.split("/").pop()}`;
  }
  return v;
};

const toPublicUrl = (v) => {
  if (!v) return "";
  if (/^https?:\/\//i.test(v) || /^data:/i.test(v)) return v; // already full or data URL
  const key = normalizeKey(v);
  const base = (
    process.env.REACT_APP_API_IMAGE_BASE_URL ||
    "https://hamilton-shop-images.s3.ap-south-1.amazonaws.com"
  ).replace(/\/+$/, "");
  return `${base}/${key}`;
};

// Handle string | array | object images defensively
const resolveAnyImage = (img) => {
  if (!img) return "";
  if (Array.isArray(img)) {
    if (img.length === 0) return "";
    return resolveAnyImage(img[0]);
  }
  if (typeof img === "object") {
    // common keys you might have on product media
    const candidate =
      img.url || img.key || img.src || img.image || img.path || img.file;
    return resolveAnyImage(candidate);
  }
  // string
  return toPublicUrl(String(img));
};
// ---------------------------------------------------------------------

const Managestock = () => {
  const [quantity, setQuantity] = useState(1);
  const [warehouse, setWarehouse] = useState(null);
  const [store, setStore] = useState(null);
  // const [pricingStockId, setPricingStockId] = useState(null);
  const [productId, setProductId] = useState(null);
  const [variantId, setVariantId] = useState(null);

  const [person, setPerson] = useState(null);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [responsiblePersonOptions, setResponsiblePersonOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  const [editData, setEditData] = useState(null);
  const [stockList, setStockList] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [variantOptions, setVariantOptions] = useState([]);

  const fetchProductsByStore = async (storeId, warehouseId) => {
    try {
      const res = await api.get(
        `${API_BASE_URL}api/products/by-warehouse/${warehouseId}`,
      );
      setProductOptions(res.data);
    } catch (error) {
      toast.error(
        `❌ ${window.translate(
          "Failed to load products for selected store & warehouse",
        )}`,
      );
    }
  };

  const fetchVariants = async (productId, warehouseId) => {
    try {
      const res = await api.get(
        `${API_BASE_URL}api/products/variants/${productId}?warehouse=${warehouseId}`,
      );

      const formatted = res.data.map((v) => ({
        label: `${v.attribute} - ${v.value}`,
        value: v._id,
      }));

      setVariantOptions(formatted);
    } catch (err) {
      toast.error("Failed to load variants");
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [warehouses, stores] = await Promise.all([
          getAllWarehouses(),
          getAllStores(),
        ]);

        const formattedWarehouses = warehouses.map((wh) => ({
          label: wh.warehouse,
          value: wh.id || wh._id,
        }));
        setWarehouseOptions(formattedWarehouses);

        const formattedStores = stores.map((st) => ({
          label: st.CustomerName,
          value: st.id,
        }));
        setStoreOptions(formattedStores);
      } catch (err) {
        toast.error(
          `❌ ${window.translate("Failed to load store or warehouse data")}`,
        );
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    const fetchStockList = async () => {
      try {
        const data = await getAllStocks();

        const formatted = data.map((item) => {
          const id = item.id;
          const productImg =
            resolveAnyImage(
              item?.product?.images || item?.image || item?.productImage,
            ) || DEFAULT_STOCK_IMAGE;

          return {
            _id: id,
            key: id,

            Warehouse: item.warehouse || "N/A",
            Shop: item.store || "N/A",

            Product: {
              Name:
                item?.product?.productName?.en ||
                item.productName ||
                item?.product?.name ||
                "N/A",
              Image: productImg,
            },

            Date:
              item.adjustmentDate && !isNaN(Date.parse(item.adjustmentDate))
                ? new Date(item.adjustmentDate).toLocaleDateString()
                : "N/A",

            Person: {
              Name:
                item.personName?.[window.lang || "en"] ||
                item.personName?.en ||
                item.personName ||
                "N/A",
              Image:
                resolveAnyImage(item.personImage) ||
                "/assets/img/users/avatar-02.jpg",
            },

            Quantity: item.quantity || 0,
            SKU: item.sku || "N/A",
            Category:
              item?.product?.category?.name?.en ||
              item?.product?.category ||
              item.category ||
              "N/A",
            Price: item.price || "0.00",
            Variant: item.variantAttribute
              ? `${item.variantAttribute} - ${item.variantValue}`
              : null,

            warehouse: item.warehouseId || null,
            store: item.storeId || null,

            pricingStock: item.pricingStock || null,
            variant: item.variant || null,
            productType: item.productType || "single",

            personName: item.personName || { en: "N/A", ar: "N/A" },
            personImage:
              resolveAnyImage(item.personImage) ||
              "/assets/img/users/avatar-02.jpg",
            productImage: productImg,
            productLabel:
              item?.product?.productName?.en ||
              item.productName ||
              item?.product?.name ||
              "N/A",
            category:
              item?.product?.category?.name?.en ||
              item?.product?.category ||
              item?.category ||
              "N/A",
            sku: item?.product?.sku || item?.sku || "N/A",
          };
        });

        setStockList(formatted);
      } catch (err) {
        console.error("Error fetching stocks:", err);
        toast.error(`❌ ${window.translate("Failed to load stock data")}`);
      }
    };

    fetchStockList();
  }, []);

  useEffect(() => {
    if (editData?.warehouse) {
      const fetchResponsiblePerson = async () => {
        try {
          const warehouseId =
            typeof editData.warehouse === "object"
              ? editData.warehouse.value
              : editData.warehouse;

          const warehouseDetails = await getWarehouseById(warehouseId);
          const person = warehouseDetails.contactPerson;
          if (person) {
            const formatted = [
              {
                label: person.en,
                value: person.en,
              },
            ];
            setResponsiblePersonOptions(formatted);
          }
        } catch (err) {
          console.error("Failed to load person:", err);
          toast.error(`❌ ${window.translate("Failed to load person")}`);
        }
      };

      fetchResponsiblePerson();
    }
  }, [editData?.warehouse]);

  const handleUpdateStock = async () => {
    if (!editData?._id) {
      toast.error(`❌ ${window.translate("Invalid stock record")}`);
      return;
    }

    const payload = {
      warehouse: editData.warehouse,
      store: editData.store,
      quantity: editData.quantity,
      personName: editData.personName,
      personImage: editData.personImage || "",
      productType: editData.productType,
      pricingStock:
        editData.productType === "single" ? editData.pricingStock : undefined,
      variant:
        editData.productType === "variable" ? editData.variant : undefined,
    };

    if (payload.productType === "single" && !payload.pricingStock) {
      toast.error(
        `❌ ${window.translate("Missing pricing stock ID for single product")}`,
      );
      return;
    }

    try {
      await updateStock(editData._id, payload);
      toast.success(` ${window.translate("Stock updated successfully")}`);
      document.getElementById("close-add-stock-btn")?.click();

      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (error) {
      console.error("Stock update failed:", error);
      toast.error(`❌ ${window.translate("Failed to update stock")}`);
    }
  };

  const handleAddStock = async () => {
    const safeQuantity = parseInt(quantity) || 0;

    if (!warehouse || !store || !productId || !person || safeQuantity < 1) {
      toast.error(`❌ ${window.translate("Please fill all required fields")}`);
      return;
    }

    if (selectedProduct?.productType === "variable" && !variantId) {
      toast.error(`❌ ${window.translate("Please fill all required fields")}`);
      return;
    }

    const selectedPerson = responsiblePersonOptions.find(
      (p) => p.value === person,
    );

    const payload = {
      warehouse,
      store,
      productId, // ✅ correct
      variant: variantId, // will be null for single
      personName: {
        en: selectedPerson?.label || "",
        ar: selectedPerson?.label || "",
      },
      personImage: selectedPerson?.image || "",
      quantity: safeQuantity,
    };

    // const payload = {
    //   warehouse,
    //   store,
    //   pricingStock: pricingStockId,
    //   personName: {
    //     en: selectedPerson?.label || "",
    //     ar: selectedPerson?.label || "",
    //   },
    //   personImage: selectedPerson?.image || "",
    //   productImage: selectedProduct?.image || "",
    //   quantity: safeQuantity,
    // };

    try {
      await createStock(payload);
      toast.success(` ${window.translate("Stock added successfully")}`);
      document.getElementById("close-add-stock-btn")?.click();

      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (error) {
      toast.error(`❌ ${window.translate("Failed to add stock")}`);
    }
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleIncrement = () => {
    setQuantity(quantity + 1);
  };

  // helpers for table mapping—(now rely on resolveAnyImage elsewhere)
  const getProductName = (it) =>
    it?.product?.productName?.en ??
    it?.productName ??
    it?.product?.name ??
    "N/A";

  const getWarehouseLabel = (it) =>
    it?.warehouse?.warehouseName?.en ?? it?.warehouse ?? "N/A";

  const getStoreLabel = (it) => it?.store?.storeName?.en ?? it?.store ?? "N/A";

  const handleDeleteStock = async () => {
    try {
      await deleteStock(deleteId);
      toast.success(` ${window.translate("Stock entry deleted successfully")}`);

      const updated = await getAllStocks();

      const formatted = updated.map((item) => {
        const id = item._id || item.id;
        const productImg =
          resolveAnyImage(
            item?.product?.images || item?.image || item?.productImage,
          ) || DEFAULT_STOCK_IMAGE;

        return {
          _id: id,
          key: id,
          Warehouse: getWarehouseLabel(item),
          Shop: getStoreLabel(item),

          Product: {
            Name: getProductName(item),
            Image: productImg,
          },

          Date: new Date(
            item.createdAt || item.adjustmentDate || Date.now(),
          ).toLocaleDateString(),

          Person: {
            Name: item?.personName?.en || item?.personName || "N/A",
            Image:
              resolveAnyImage(item?.personImage) ||
              DEFAULT_STOCK_IMAGE,
          },

          Quantity: item?.quantity ?? 0,
          sku: item?.product?.sku || item?.sku || "N/A",
          category:
            item?.product?.category?.name?.en ||
            item?.product?.category ||
            item?.category ||
            "N/A",

          productLabel: getProductName(item),
          productImage: productImg,

          pricingStock: item?.pricingStock || null,
          warehouse: item?.warehouse?.warehouse || item?.warehouse || "N/A",
          store: item?.store?.CustomerName || item?.store || "N/A",
          personName: item?.personName,
        };
      });
      setStockList(formatted);
      document.getElementById("close-add-stock-btn")?.click();

      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (error) {
      console.error("Delete error:", error);
      toast.error(`❌ ${window.translate("Failed to delete stock entry")}`);
    }
  };

  const handleEditDecrement = () => {
    setEditData((prev) => ({
      ...prev,
      quantity: Math.max(1, (prev?.quantity || 1) - 1),
    }));
  };

  const handleEditIncrement = () => {
    setEditData((prev) => ({
      ...prev,
      quantity: (prev?.quantity || 1) + 1,
    }));
  };

  const columns = [
    {
      title: window.translate("Warehouse"),
      dataIndex: "Warehouse",
      sorter: (a, b) => a.Warehouse.localeCompare(b.Warehouse),
    },
    {
      title: window.translate("Stores"),
      dataIndex: "Shop",
      sorter: (a, b) => a.Shop.localeCompare(b.Shop),
    },
    {
      title: window.translate("Product"),
      dataIndex: "Product",
      render: (_, record) => (
        <span className="userimgname">
          <img
            src={
              resolveAnyImage(record.Product.Image) ||
              DEFAULT_STOCK_IMAGE
            }
            alt="Product"
            style={{
              width: "80px",
              height: "auto",
              borderRadius: "4px",
              objectFit: "cover",
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = DEFAULT_STOCK_IMAGE;
            }}
          />{" "}
          <Link to="#">{record.Product.Name}</Link>
        </span>
      ),
      sorter: (a, b) => a.Product.Name.localeCompare(b.Product.Name),
    },
    {
      title: window.translate("Date"),
      dataIndex: "Date",
      sorter: (a, b) => new Date(a.Date) - new Date(b.Date),
    },
    {
      title: window.translate("Person"),
      dataIndex: "Person",
      render: (_, record) => (
        <span className="userimgname">
          <Link to="#">{record.Person.Name}</Link>
        </span>
      ),
      sorter: (a, b) => a.Person.Name.localeCompare(b.Person.Name),
    },
    {
      title: window.translate("Qty"),
      dataIndex: "Quantity",
      sorter: (a, b) => a.Quantity - b.Quantity,
    },
    {
      title: window.translate("Variant"),
      dataIndex: "Variant",
      render: (text) => (text ? <span>{text}</span> : <span>-</span>),
    },
    {
      title: window.translate("Price"),
      dataIndex: "Price",
      render: (price) => `${price} KD`,
      sorter: (a, b) => parseFloat(a.Price) - parseFloat(b.Price),
    },
    {
      title: "",
      dataIndex: "action",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#edit-units"
              onClick={() => setEditData(record)}
            >
              <Edit className="feather-edit" />
            </Link>
            <Link
              className="confirm-text p-2"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              to="#"
              onClick={() => setDeleteId(record._id)}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>{window.translate("Manage Stock")}</h4>
                <h6>{window.translate("Manage your stock")}</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
              >
                <i className="ti ti-circle-plus me-2 ms-2"></i>
                {window.translate("Add Stock")}
              </Link>
            </div>
          </div>

          <div className="card table-list-card  manage-stock">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    Warehouse
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Lavish Warehouse
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Quaint Warehouse{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Traditional Warehouse
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Cool Warehouse
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    Store
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Electro Mart
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Quantum Gadgets
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Prime Bazaar
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Gadget World
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    Product
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Lenovo IdeaPad 3
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Beats Pro{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Nike Jordan
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Apple Series 5 Watch
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="custom-datatable-filter table-responsive">
                {stockList.length === 0 ? (
                  <div className="text-center mt-4">
                    <p>{window.translate("No stock entries found")}.</p>
                  </div>
                ) : (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6 className="mt-2 pe-2 ps-4">
                        {window.translate("Total Stock Records")}:{" "}
                        <strong>{stockList.length}</strong>
                      </h6>
                    </div>
                    <Table columns={columns} dataSource={stockList} />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      <CommonDeleteModal
        title={window.translate("Delete Stock Entry")}
        message="Are you sure you want to delete this stock entry?"
        onConfirm={handleDeleteStock}
      />

      {/* Add Stock */}
      <div className="modal fade" id="add-units">
        <div className="modal-dialog modal-dialog-centered stock-adjust-modal">
          <div className="modal-content">
            <div className="modal-header">
              <div className="page-title">
                <h4>{window.translate("Add Stock")}</h4>
              </div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 mb-3">
                  <label className="form-label">
                    {window.translate("Warehouse")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <Select
                    options={warehouseOptions}
                    onChange={async (e) => {
                      const selectedWarehouseId = e.value;
                      setWarehouse(selectedWarehouseId);

                      try {
                        const warehouseDetails =
                          await getWarehouseById(selectedWarehouseId);
                        const person = warehouseDetails.contactPerson;

                        if (person) {
                          setResponsiblePersonOptions([
                            {
                              label: person.en,
                              value: person.en,
                              image: "/assets/img/users/avatar-02.jpg",
                            },
                          ]);
                          setPerson(person.en);
                        } else {
                          setResponsiblePersonOptions([]);
                          setPerson(null);
                        }

                        if (store) {
                          await fetchProductsByStore(
                            store,
                            selectedWarehouseId,
                          );
                        }
                      } catch {
                        toast.error(
                          `❌ ${window.translate(
                            "Failed to fetch warehouse/responsible person",
                          )}`,
                        );
                      }
                    }}
                  />
                </div>
                <div className="col-lg-12 mb-3">
                  <label className="form-label">
                    {window.translate("Store")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <Select
                    options={storeOptions}
                    onChange={async (e) => {
                      const selectedStoreId = e.value;
                      setStore(selectedStoreId);

                      if (warehouse) {
                        await fetchProductsByStore(selectedStoreId, warehouse);
                      }
                    }}
                  />
                </div>
                <div className="col-lg-12 mb-3">
                  <label className="form-label">
                    {window.translate("Responsible Person")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <Select
                    options={responsiblePersonOptions}
                    value={responsiblePersonOptions.find(
                      (p) => p.value === person,
                    )}
                    onChange={(e) => setPerson(e.value)}
                    placeholder="Select responsible person"
                  />
                </div>
                <div className="col-lg-12 mb-3">
                  <label className="form-label">
                    {window.translate("Product")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <Select
                    options={productOptions}
                    getOptionLabel={(e) => `${e.label} (${e.sku})`}
                    onChange={async (e) => {
                      setProductId(e.productId);
                      setSelectedProduct(e);
                      setVariantId(null);

                      if (e.productType === "variable") {
                        await fetchVariants(e.productId, warehouse);
                      } else {
                        setVariantOptions([]);
                      }
                    }}
                    placeholder="Select product"
                  />
                </div>

                {selectedProduct && (
                  <div className="col-lg-12 mb-3">
                    <div className="modal-body-table">
                      <div className="table-responsive">
                        <table className="table datanew">
                          <thead>
                            <tr>
                              <th>{window.translate("Product")}</th>
                              <th>{window.translate("SKU")}</th>
                              <th>{window.translate("Category")}</th>
                              <th>{window.translate("Qty")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={
                                      resolveAnyImage(selectedProduct.image) ||
                                      DEFAULT_STOCK_IMAGE
                                    }
                                    alt="product"
                                    className="avatar avatar-md me-2 ms-2"
                                    style={{ gap: "12px" }}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = DEFAULT_STOCK_IMAGE;
                                    }}
                                  />
                                  <span>{selectedProduct.label}</span>
                                </div>
                              </td>
                              <td>{selectedProduct.sku}</td>
                              <td>{selectedProduct.category}</td>
                              <td style={{ minWidth: 200 }}>
                                <div
                                  className="qty-chip"
                                  role="group"
                                  aria-label="Quantity selector"
                                >
                                  <button
                                    type="button"
                                    className="qty-btn"
                                    onClick={handleDecrement}
                                    aria-label="Decrease quantity"
                                  >
                                    <MinusCircle />
                                  </button>

                                  <input
                                    type="number"
                                    className="qty-input"
                                    value={quantity}
                                    min={1}
                                    inputMode="numeric"
                                    onChange={(e) => {
                                      const val = parseInt(e.target.value, 10);
                                      setQuantity(
                                        isNaN(val) ? 1 : Math.max(1, val),
                                      );
                                    }}
                                    aria-live="polite"
                                  />

                                  <button
                                    type="button"
                                    className="qty-btn"
                                    onClick={handleIncrement}
                                    aria-label="Increase quantity"
                                  >
                                    <PlusCircle />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                {/* Variant Selector (ONLY for variable products) */}
                {selectedProduct?.productType === "variable" && (
                  <div className="col-lg-12 mb-3">
                    <label className="form-label">
                      {window.translate("Variant")}{" "}
                      <span className="text-danger">*</span>
                    </label>

                    <Select
                      options={variantOptions}
                      value={variantOptions.find((v) => v.value === variantId)}
                      onChange={(e) => setVariantId(e.value)}
                      placeholder="Select variant"
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary me-2"
                data-bs-dismiss="modal"
                id="close-add-stock-btn"
              >
                {window.translate("Cancel")}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleAddStock}
                data-bs-dismiss="modal"
              >
                {window.translate("Add Stock")}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Stock */}

      {/* Edit Stock */}
      <div className="modal fade" id="edit-units">
        <div className="modal-dialog modal-dialog-centered stock-adjust-modal">
          <div className="modal-content">
            {editData && (
              <>
                <div className="modal-header">
                  <div className="page-title">
                    <h4>{window.translate("Edit Stock")}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-12 mb-3">
                      <label className="form-label">
                        {window.translate("Warehouse")}
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        options={warehouseOptions}
                        value={warehouseOptions.find(
                          (w) => w.value === editData?.warehouse,
                        )}
                        onChange={(e) =>
                          setEditData((prev) => ({
                            ...prev,
                            warehouse: e.value,
                          }))
                        }
                        placeholder="Choose Warehouse"
                      />
                    </div>

                    <div className="col-lg-12 mb-3">
                      <label className="form-label">
                        {window.translate("Store")}
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        options={storeOptions}
                        value={storeOptions.find(
                          (s) => s.value === editData?.store,
                        )}
                        onChange={(e) =>
                          setEditData((prev) => ({ ...prev, store: e.value }))
                        }
                        placeholder="Choose Store"
                      />
                    </div>

                    <div className="col-lg-12 mb-3">
                      <label className="form-label">
                        {window.translate("Responsible Person")}
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        options={responsiblePersonOptions}
                        value={responsiblePersonOptions.find(
                          (p) => p.label === editData?.personName?.en,
                        )}
                        onChange={(e) =>
                          setEditData((prev) => ({
                            ...prev,
                            personName: { en: e.label, ar: e.label },
                            personImage: e.image,
                          }))
                        }
                        placeholder="Choose Person"
                      />
                    </div>

                    <div className="col-lg-12 mb-3">
                      <label className="form-label">
                        {window.translate("Product")}
                      </label>
                      <input
                        className="form-control"
                        value={editData?.productLabel || "Product"}
                        readOnly
                      />
                    </div>

                    <div className="col-lg-12">
                      <div className="modal-body-table">
                        <div className="table-responsive">
                          <table className="table datanew">
                            <thead>
                              <tr>
                                <th>{window.translate("Product")}</th>
                                <th>{window.translate("SKU")}</th>
                                <th>{window.translate("Category")}</th>
                                <th>{window.translate("Qty")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <img
                                      src={
                                        resolveAnyImage(
                                          editData?.productImage,
                                        ) ||
                                        DEFAULT_STOCK_IMAGE
                                      }
                                      alt="product"
                                      className="avatar avatar-md me-2 ms-2"
                                      style={{ gap: "12px" }}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = DEFAULT_STOCK_IMAGE;
                                      }}
                                    />
                                    <span>
                                      {editData?.productLabel || "Product"}
                                    </span>
                                  </div>
                                </td>
                                <td>{editData?.sku || "N/A"}</td>
                                <td>{editData?.category || "N/A"}</td>
                                <div className="qty-chip">
                                  <button
                                    type="button"
                                    className="qty-btn"
                                    onClick={handleEditDecrement}
                                  >
                                    <MinusCircle />
                                  </button>
                                  <input
                                    type="number"
                                    className="qty-input"
                                    value={editData?.quantity || 1}
                                    min={1}
                                    inputMode="numeric"
                                    onChange={(e) =>
                                      setEditData((prev) => ({
                                        ...prev,
                                        quantity: Math.max(
                                          1,
                                          parseInt(e.target.value, 10) || 1,
                                        ),
                                      }))
                                    }
                                  />
                                  <button
                                    type="button"
                                    className="qty-btn"
                                    onClick={handleEditIncrement}
                                  >
                                    <PlusCircle />
                                  </button>
                                </div>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    data-bs-dismiss="modal"
                  >
                    {window.translate("Cancel")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleUpdateStock}
                    data-bs-dismiss="modal"
                  >
                    {window.translate("Save Changes")}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* /Edit Stock */}
    </>
  );
};

export default Managestock;
